import { UserMissionLevel } from './UserMissionLevel'
import { withUserMissionLevel } from './withUserMissionLevel'

const ConnectedUserMissionLevel = withUserMissionLevel(UserMissionLevel)

export { ConnectedUserMissionLevel as UserMissionLevel }
